/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-11 15:59:56
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-10-12 19:50:37
 */
// 达人信息
export function DrInfo(h) {
	return h('div', [h('span', '达人信息')]);
}
// 团长信息
export function TzInfo(h) {
	return h('div', [h('span', '团长信息')]);
}
// 收货地址
export function Address(h) {
	return h('div', [h('span', { style: { color: 'red' } }, '*'), h('span', '收货地址')]);
}
//达人联系人
export function DrContacts(h) {
	return h('div', [h('span', { style: { color: 'red' } }, '*'), h('span', '达人联系人')]);
}
